import { render, staticRenderFns } from "./culturalNews.vue?vue&type=template&id=2bc1367c&scoped=true&"
import script from "./culturalNews.vue?vue&type=script&lang=js&"
export * from "./culturalNews.vue?vue&type=script&lang=js&"
import style0 from "./culturalNews.vue?vue&type=style&index=0&id=2bc1367c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1367c",
  null
  
)

component.options.__file = "culturalNews.vue"
export default component.exports